import request from '@/system/engine/request';
import config from '@/system/engine/config';

export function logout(postData){
	const data = request({
		url: config.url+'common/progress/logout',
		method: 'post',
		data: postData
	});
	
	return Promise.resolve(data);
}